import { render, staticRenderFns } from "./BaseConfirm.vue?vue&type=template&id=1022987c&scoped=true&"
import script from "./BaseConfirm.vue?vue&type=script&lang=ts&"
export * from "./BaseConfirm.vue?vue&type=script&lang=ts&"
import style0 from "./BaseConfirm.vue?vue&type=style&index=0&id=1022987c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1022987c",
  null
  
)

export default component.exports